import { createFileRoute } from '@tanstack/react-router';
import { FormsIntegrationAlias } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/forms_/$type')({
  component: FormsTypeAliasRoute,
});

function FormsTypeAliasRoute() {
  const { workspaceId, type } = Route.useParams();
  return <FormsIntegrationAlias workspaceId={String(workspaceId)} type={type} />;
}
